import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TemplateNode } from '../certification-template-editor.component';

@Component({
  selector: 'app-template-tree-viewer',
  templateUrl: './template-tree-viewer.component.html',
  styleUrls: ['./template-tree-viewer.component.css']
})
export class TemplateTreeViewerComponent {
  constructor(private cd: ChangeDetectorRef) { }
  @Input() nodes: TemplateNode[] = [];

  getTypeLabel(type: string): string {
    switch (type) {
      case 'number': return 'Zahl';
      case 'boolean': return 'Bool';
      case 'array': return 'Liste';
      case 'object': return 'Objekt';
      default: return 'Text';
    }
  }
  toggleExpand(node: TemplateNode) {
    node.expanded = !node.expanded;
    console.log(node.expanded);
    this.cd.detectChanges();
  }
}
